import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxEditorModule } from 'ngx-editor';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EmptyPipe } from '../pipes/empty.pipe';
import { EnergyPipe, EnergyUnitPipe, KwhEnergyPipe } from '../pipes/energy.pipe';
import { EnergyKwhInputDirective } from '../directives/energy-kwh-input.directive';
import { ISChartModule, ISDateTimePickerModule, ISDialogModule, ISFileUploadModule, ISFormLayoutModule, ISLibModule, ISMultiSelectModule, ISProgressBarModule, ISSelectModule, ISTabLayoutModule, ISTableModule, ISVerticalStepperModule } from 'is-lib';

const ISModules = [
    ISLibModule,
    ISTableModule,
    ISDateTimePickerModule,
    ISVerticalStepperModule,
    ISFormLayoutModule,
    ISSelectModule,
    ISTabLayoutModule,
    ISProgressBarModule,
    ISMultiSelectModule,
    ISDialogModule,
    ISFileUploadModule,
    ISChartModule
];

const MatModules= [
    MatProgressBarModule,
    MatExpansionModule,
    MatTooltipModule,
    CdkMenuModule,
    CdkAccordionModule,
    MatSnackBarModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    NgbCollapseModule, 
    ClipboardModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatExpansionModule
]
  

@NgModule({
  declarations: [
    EmptyPipe,
    EnergyPipe,
    EnergyUnitPipe,
    KwhEnergyPipe,
    EnergyKwhInputDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxSpinnerModule.forRoot(),
    NgxEditorModule,
    ...ISModules,
    ...MatModules
  ],
  exports: [
    EmptyPipe,
    EnergyPipe,
    EnergyUnitPipe,
    KwhEnergyPipe,
    EnergyKwhInputDirective,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxSpinnerModule,
    NgxEditorModule,
    ...ISModules,
    ...MatModules
  ]
})
export class SharedModule { }